import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, style, ...props }, ref) => {
  return (
    <input
      type={type}
      style={{
        backgroundColor: '#111827',
        border: '1px solid #1F2937',
        borderRadius: '0px',
        color: '#FFFFFF',
        fontFamily: "'Sora', sans-serif",
        ...style
      }}
      className={cn(
        "flex h-12 w-full px-4 py-2 text-sm shadow-sm transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#6B7280] focus:outline-none focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] focus:shadow-[0_0_15px_rgba(0,230,118,0.15)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
